import { tryAxios } from '@/api/common/auth'
import { DynamicAttachData } from '@/api/common/attach'
import { urlPrefix } from '@/configs/api'
import { UnitPositionMapData } from '@/api/common/mapData'
// import { newGuid } from '@/configs/functions'

const apiUrl = `${urlPrefix}/CruiseEvent`
//#region select数据源相关api
const GetStatusList = `${apiUrl}/GetStatusList`
const GetList = `${apiUrl}`
const Delete = (id: number) => `${apiUrl}/${id}`
const Get = (id: number) => `${apiUrl}/${id}`
const View = (id: number) => `${apiUrl}/view/${id}`
const Post = `${apiUrl}`
const Put = (id: number) => `${apiUrl}/${id}`
const PostHandle = `${apiUrl}/SubmitHandle`
const PostResponse = `${apiUrl}/SubmitResponse`
const GetHandleTypes = `${apiUrl}/GetHandleTypes`
const GetResponseTypes = `${apiUrl}/GetResponseTypes`
const GetHandleInfo = (id: number) => `${apiUrl}/handle/${id}`
const GetResponseInfo = (id: number) => `${apiUrl}/response/${id}`
const ViewResponseInfo = (id: number) => `${apiUrl}/view/response/${id}`

const PostGrade = `${apiUrl}/SubmitGrade`
const GetResponseAuditResult = `${apiUrl}/GetResponseAuditResult`
const AuditResponse = `${apiUrl}/AuditResponse`
//#endregion
export const emptyResponseAudit: ResponseAuditData = {
    Id: 0,
    ResponseId: 0,
    EventId: 0,

    AuditResult: 0,
    EventResult: 0,
    Comments: ''
}
export const emptyCruiseEvent: CruiseEventData = {
    Id: 0,
    CruiseId: 0,
    IssueFrom: 0,
    IssueType: 0,
    IssueSpecification: '',
    IssueLevel: 0,
    IssueLevelSpec: '',
    ResponsiblityUnit: '',
    ResponsiblityPerson: '',
    Status: 1,
    Comments: '',
    UpdateDate: new Date(),

    CruiseDate: new Date(),
    IssueFromName: '',
    IssueTypeName: '',
    IssueLevelName: '',

    ListId: 0,
    UnitId: 0,
    UnitCode: '',
    UnitName: '',

    CruiseAttachTypePic: 0,
    CruiseAttachGuidPic: '',
    CruiseAttachTypeVideo: 0,
    CruiseAttachGuidVideo: '',
    HandleList: [],
    ResponseList: [],
    ActionList: [],

    CruiseItemIds: [],
    CruiseItemList: [],

    CruisePointId: 0,
    CruisePointName: '',
    CruisePointLongitude: 0,
    CruisePointLatitude: 0,
    UnitPositionAreas: []
}
export const emptyEventHandle: EventHandleData = {
    Id: 0,
    HandleType: 0,
    MeasureDateFrom: '',
    MeasureDateTo: '',
    MeasureTarget: '',
    Comments: '',

    HandleTypeName: '',
    EventList: [],
    AttachTypePic: 0,
    AttachGuidPic: '',
    DynamicAttachType: 0,
    DynamicAttachs: []
}
export const emptyEventResponse: EventResponseData = {
    Id: 0,
    ResponseType: 0,
    MeasurePeriod: '',
    MeasureSteps: '',
    MeasureTeamDesc: '',
    ResponseStatus: 0,
    Comments: '',

    ResponseTypeName: '',
    StatusText: '',
    EventList: [],
    ActionList: [],
    AttachTypePic: 0,
    AttachGuidPic: '',
    DynamicAttachType: 0,
    DynamicAttachs: []
}
export interface CruiseEventData {
    Id: number
    CruiseId: number
    IssueFrom: number
    IssueType: number
    IssueSpecification: string
    IssueLevel: number
    IssueLevelSpec: string
    ResponsiblityUnit: string
    ResponsiblityPerson: string
    Status: number
    Comments: string
    UpdateDate: Date

    //#region relation
    CruiseDate: Date
    IssueFromName: string
    IssueTypeName: string
    IssueLevelName: string

    ListId: number
    UnitId: number
    UnitCode: string
    UnitName: string
    CruiseAttachTypePic: number
    CruiseAttachGuidPic: string
    CruiseAttachTypeVideo: number
    CruiseAttachGuidVideo: string

    HandleList: EventHandleData[]
    ResponseList: EventResponseData[]
    ActionList: any[]

    CruiseItemIds: number[]
    CruiseItemList: any[]

    CruisePointId: number
    CruisePointName: string
    CruisePointLongitude: number
    CruisePointLatitude: number
    UnitPositionAreas: UnitPositionMapData[]
    //#endregion
}
export interface CruiseEventListData {
    Id: number
    IsTask: boolean
    ListId: number
    UnitId: number
    UnitCode: string
    UnitName: string
    LevelId: number
    LevelName: string
    ClassifyId: number
    ClassifyName: string
    CityId: number
    CityName: string
    CountyId: number
    CountyName: string
    AreaName: string

    CruiseDate: Date
    IssueType: number
    IssueTypeName: string
    IssueLevel: number
    IssueLevelName: string
    IssueSpecification: string
    ResponsiblityUnit: string
    ResponsiblityPerson: string
    Status: number
    UpdateDate: Date
    HandleId: number
    ResponseId: number
    //响应状态 0.删除 1.提交 2.退回 3.终止 4.区县局待审 5.市级待审 6.省级待审 7.已审核
    ResponseStatus: number

    DoHandle: boolean
    DoResponse: boolean
    DoResponseEdit: boolean
    DoResponseAudit: boolean
    DoEdit: boolean
    DoDel: boolean
    DoAudit: boolean
}
export interface EventHandleData {
    Id: number
    HandleType: number
    MeasureDateFrom: string
    MeasureDateTo: string
    MeasureTarget: string
    Comments: string

    HandleTypeName: string
    EventList: CruiseEventData[]

    AttachTypePic: number
    AttachGuidPic: string
    DynamicAttachType: number
    DynamicAttachs: DynamicAttachData[]
}
export interface EventResponseData {
    Id: number
    ResponseType: number
    MeasurePeriod: string
    MeasureSteps: string
    MeasureTeamDesc: string
    ResponseStatus: number
    Comments: string

    ResponseTypeName: string
    StatusText: string
    EventList: CruiseEventData[]
    ActionList: ResponseActionData[]

    AttachTypePic: number
    AttachGuidPic: string
    DynamicAttachType: number
    DynamicAttachs: DynamicAttachData[]
}
export interface ResponseActionData {
    Id: number
    ResponseId: number
    ActionType: number
    Comments: string
    NewUserId: number
    NewDate: Date

    UserName: string
    ActionTypeName: string
}
export interface ResponseAuditData {
    Id: number
    ResponseId: number
    EventId: number

    AuditResult: number
    EventResult: number
    Comments: string
}
export const getHandleTypes = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetHandleTypes,
        params: { type: firstType }
    })
}
export const getResponseTypes = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetResponseTypes,
        params: { type: firstType }
    })
}
export const getStatusList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetStatusList,
        params: { type: firstType }
    })
}
export const getList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: Get(id)
    })
}
export const viewInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: View(id)
    })
}
export const postData = (form: any) => {
    return tryAxios({
        method: 'post',
        url: Post,
        data: form
    })
}
export const putData = (id: number, form: any) => {
    return tryAxios({
        method: 'put',
        url: Put(id),
        data: form
    })
}
export const postGrade = (form: any) => {
    return tryAxios({
        method: 'post',
        url: PostGrade,
        data: form
    })
}
export const postHandle = (form: any) => {
    return tryAxios({
        method: 'post',
        url: PostHandle,
        data: form
    })
}
export const postResponse = (form: any) => {
    return tryAxios({
        method: 'post',
        url: PostResponse,
        data: form
    })
}
export const getResponseAuditResult = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetResponseAuditResult,
        params: { type: firstType }
    })
}
export const auditResponse = (form: any) => {
    return tryAxios({
        method: 'post',
        url: AuditResponse,
        data: form
    })
}
export const getHandleInfo = () => {
    return tryAxios({
        method: 'get',
        url: GetHandleInfo(0)
    })
}
export const viewHandle = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetHandleInfo(id)
    })
}
export const getNewResponse = () => {
    return tryAxios({
        method: 'get',
        url: GetResponseInfo(0)
    })
}
export const getResponseInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetResponseInfo(id)
    })
}
export const viewResponse = (id: number) => {
    return tryAxios({
        method: 'get',
        url: ViewResponseInfo(id)
    })
}